import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";
import RushType from "../enums/rush-type";
import RushedByPositionPref from "./position-pref/rushed-by-position-pref";

export default class Rush extends Fragment {
    constructor(player, fieldPosition, rushType) {
        super();
        this.rushedBy = player;
        this.fieldPosition = fieldPosition;
        this.rushType = rushType;

        this.requiredData = [
            {
                name: "rushedBy",
                type: FragmentDataType.Player,
                displayName: "Rushed by",
                title: (team) => `Rushed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new RushedByPositionPref(play, this).resolve()
            },
            {
                name: "rushType",
                type: FragmentDataType.RushType,
                displayName: "Rushed to",
                title: "Rushed to",
                subtitle: () => "Select direction of rush",
                isEditable: true,
                optional: true
            },
            {
                name: "fieldPosition",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    getFragmentTeamId() {
        return this.rushedBy?.teamId;
    }

    getFieldPosition() {
        return this.fieldPosition;
    }

    summarize(summaryContext, stringifier) {
        let message = `${stringifier.firstInitial(this.rushedBy)} rush`;

        if (this.rushType && this.rushType.code !== RushType.SKIP.code) {
            message += ` ${this.rushType.name.toLowerCase()}`;
        }

        message += ` for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.fieldPosition
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.fieldPosition || this.fieldPosition === 0) {
            summaryContext.fieldPosition = this.fieldPosition;
        }

        summaryContext.playerInPossession = this.rushedBy;
    }

    getPlayers() {
        return [this.rushedBy];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            rushedBy: playerReducer(this.rushedBy)
        };
    }

    excludeRequiredData(rd, gameConfig) {
        if (rd.name === "rushType") {
            return !gameConfig.general.rushType;
        }

        return false;
    }
}
